import { AfterViewInit, Component, OnInit, SimpleChanges } from '@angular/core';
import * as numeral from 'numeral';
import * as moment from 'moment';
import * as _ from 'underscore';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DatatableV5Component } from '../datatable-v5/datatable-v5.component';
import { DropDownSettings } from '../lazy-dropdown/lazy-dropdown.component';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import * as jQuery from 'jquery';
@Component({
	selector: 'app-line-items',
	templateUrl: './line-items.component.html',
	styleUrls: ['./line-items.component.css']
})
export class LineItemsComponent extends DatatableV5Component implements OnInit {
	public dropdownSettings = {
		clearAllText: 'Clear All',
		clearable: false,
		closeOnSelect: false,
		loading: false,
		loadingText: 'Loading Line Items',
		multiple: true,
		notFoundText: 'No Line Items Found',
		placeholder: 'Select Line Items',
		searchable: true,
		virtualScroll: true
	} as DropDownSettings;
	public defaultSort: any;
	public gamCampaigns;
	public updatedCampaigns;
	public updatedAdvertisers;
	public productPermission: string;
	public addClicksClass: boolean = true;
	public isR13: boolean = false;
	public cssClasses: any;
	constructor(protected analyticsService: AnalyticsService, analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
		EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).subscribe((response: any) => {
			this.checkUpdatedCampaigns();
		});

		EmitterService.get(EVENT_EMITTERS.CAMPAIGN_LOADED).subscribe((response: any) => {
			this.initiaLoadCamapigns();
		});

		EmitterService.get(EVENT_EMITTERS.REFRESH_CAMPAIGNS).subscribe((response: any) => {
			this.initiaLoadCamapigns();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.isR13 = this.analyticsDataModel.config.version === 'R13' ? true : false;
		if (this.isR13) {
			this.cssClasses = {
				pagerLeftArrow: 'datatable-icon-left',
				pagerNext: 'datatable-icon-skip',
				pagerPrevious: 'datatable-icon-prev',
				pagerRightArrow: 'datatable-icon-right',
				sortAscending: 'fa fa-long-arrow-down',
				sortDescending: 'fa fa-long-arrow-up'
			};
		}
		if (typeof this.datatableconfig !== 'object') this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.productPermission =
			this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL
				? 'has_preroll_access'
				: this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY
				? 'has_display_access'
				: this.analyticsDataModel.getCurrentPath() === PATHS.GAM
				? 'has_gam_access'
				: '';
		this.defaultSort =
			this.datatableconfig.sortBy && typeof this.datatableconfig.sortBy !== 'string' ? this.datatableconfig.sortBy : [];
		this.showLineItems = this.showLoad = true;
		this.updatedCampaigns = this.analyticsDataModel.campaignsListForDropDown;
		this.updatedAdvertisers = this.analyticsDataModel.selectedAdvertisersListForDropDown;
		this.checkUpdatedCampaigns();
	}

	selectAll() {
		this.selectedList = this.dropdownList.filter((item) => item['lineItem'] != 'Total');
		this.dropdownList = this.dropdownList.map((item) => ({ ...item, ...{ selected: true } }));
	}

	unselectAll() {
		this.selectedList = [];
		this.dropdownList = this.dropdownList.map((item) => ({ ...item, ...{ selected: false } }));
	}

	onAdd(item: any): void {
		this.dropdownList.forEach((element) => {
			element.selected = this.isR6
				? element.lineItem == item.lineItem && element.impressions == item.impressions && element.clicks == item.clicks
					? true
					: element.selected
				: element.lineItem == item.lineItem
				? true
				: element.selected;
		});
	}

	onRemove(item: any): void {
		this.dropdownList.forEach((element) => {
			element.selected = this.isR6
				? element.lineItem == item.value.lineItem &&
				  element.impressions == item.value.impressions &&
				  element.clicks == item.value.clicks
					? false
					: element.selected
				: element.lineItem == item.value.lineItem
				? false
				: element.selected;
		});
	}

	onClose(): void {
		let lineItemsTotal = {};
		this.lineItemTableData = this.selectedList.filter((item) => item['lineItem'] != 'Total');
		this.lineItemTableData.sort((a, b) => b.clicks - a.clicks);
		this.dataTableObj.columns.forEach((item) => {
			let columnKey = item['columnKey'];
			let columnType = item['columnType'];
			let totalOfEachMetric = {};
			totalOfEachMetric[columnType == 'string' ? item['columnKey'] : 'formatted_' + item['columnKey']] =
				totalOfEachMetric[columnType == 'string' ? item['columnKey'] : item['columnKey']] =
					columnType.toUpperCase() == 'STRING'
						? 'Total'
						: this.sumOfLineItems(columnKey, this.lineItemTableData)[columnKey];
			lineItemsTotal = { ...lineItemsTotal, ...totalOfEachMetric };
		});
		lineItemsTotal['formatted_impressions'] = numeral(lineItemsTotal['impressions']).format('0,0');
		lineItemsTotal['formatted_clicks'] = numeral(lineItemsTotal['clicks']).format('0,0');
		lineItemsTotal['formatted_completions'] = numeral(lineItemsTotal['completions']).format('0,0');
		lineItemsTotal['formatted_clicks_rate'] = lineItemsTotal['formatted_clicks_percent'] =
			((lineItemsTotal['clicks'] / lineItemsTotal['impressions']) * 100).toFixed(2) + '%';
		lineItemsTotal['formatted_completion_rate'] =
			((lineItemsTotal['completions'] / lineItemsTotal['impressions']) * 100).toFixed(2) + '%';
		this.lineItemTableData.push(lineItemsTotal);
		this.dropdownList = this.dropdownList.filter((item) => item['lineItem'] != 'Total');
		this.selectedList = this.selectedList.filter((item) => item['lineItem'] != 'Total');
	}

	requestData(): void {
		this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
		this.showLoad = true;
		this.showLineItems = true;
		if (this.toplinks?.length > 0 && this.isemail) {
			this.hasData = true;
			this.showLoad = false;
			this.dataTableObj.data = this.toplinks;
			this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
			this.processResponseData(this.toplinks);
		} else {
			this.widgetDataSubscription = this.analyticsService
				.processWidgetRequest(this.key, this.columns, this.queryorderby)
				.subscribe((res: any) => {
					this.showLoad = false;
					this.dataTableObj.data = [];
					this.showLineItems = true;
					if (res.success && res.data.length > 0) {
						this.hasData = true;
						this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
						this.processResponseData(res.data);
					} else {
						this.hasData = this.showLineItems = false;
						this.dataTableObj.data = this.lineItemTableData = this.selectedList = [];
					}
					this.showLineItemsWidget();
				});
		}
	}

	checkUpdatedCampaigns() {
		this.updatedCampaigns = this.analyticsDataModel.selectedCampaigns;
	}

	initiaLoadCamapigns() {
		this.updatedCampaigns = this.analyticsDataModel.campaignsListForDropDown.filter((item) => {
			if (this.analyticsDataModel.selectedCampaigns.find((campaign) => campaign.id == item.id)) {
				return item;
			}
		});
	}

	showLineItemsWidget() {
		this.showLineItems = this.showLoad = true;
		this.updatedAdvertisers = this.analyticsDataModel.selectedAdvertisers;
		if (this.updatedCampaigns.length > 0 && this.updatedAdvertisers.length > 0) {
			this.updatedCampaigns = this.updatedCampaigns.filter(
				(campaign) => campaign.permission.includes(this.productPermission) && campaign.active && campaign.isGAM
			);
			this.showLineItems = this.updatedCampaigns.length > 0 || this.lineItemTableData.length > 0 ? true : false;
		} else {
			this.showLineItems = false;
		}
		if (this.showLineItems) {
			jQuery('app-nav-tab .nav.nav-link-tabs .nav-item #lineitems-tab').css('display', 'flex');
		} else {
			jQuery('app-nav-tab .nav.nav-link-tabs .nav-item #lineitems-tab').css('display', 'none');
		}
		this.showLoad = false;
	}

	comparator(propertyName: string, a: any, b: any, c: any, d: any): number {
		if (propertyName != 'lineItem') {
			if (
				parseFloat(c[propertyName]) < parseFloat(d[propertyName]) &&
				c['lineItem'] !== 'Total' &&
				d['lineitem'] !== 'Total'
			) {
				return 1;
			}
			if (
				parseFloat(c[propertyName]) > parseFloat(d[propertyName]) &&
				c['lineItem'] !== 'Total' &&
				d['lineitem'] !== 'Total'
			) {
				return -1;
			}
		} else if (propertyName === 'lineItem') {
			if (c[propertyName] < d[propertyName] && c['lineItem'] !== 'Total' && d['lineitem'] !== 'Total') {
				return 1;
			}
			if (c[propertyName] > d[propertyName] && c['lineItem'] !== 'Total' && d['lineitem'] !== 'Total') {
				return -1;
			}
		}
	}
	onSort(event: any): void {
		jQuery('.r1301-line-items.datatable-r10 .intial-sort-header .datatable-header-cell-template-wrap').removeClass(
			'primary-color'
		);
		jQuery(
			'.r1301-line-items.datatable-r10 .intial-sort-header .datatable-header-cell-template-wrap .sort-btn'
		).removeClass('fa fa-long-arrow-down');
		this.addClicksClass = false;
	}
	compareItems(item1: any, item2: any): boolean {
		return (
			item1.lineItem === item2.lineItem && item1.impressions === item2.impressions && item1.clicks === item2.clicks
		);
	}
	ngAfterContentChecked(): void {
		if (this.addClicksClass) {
			jQuery(
				' .r1301-line-items.datatable-r10 .intial-sort-header .datatable-header-cell-template-wrap .sort-btn'
			).addClass('fa fa-long-arrow-down');
			jQuery('.r1301-line-items.datatable-r10 .intial-sort-header .datatable-header-cell-template-wrap').addClass(
				'primary-color'
			);
		}
	}
}
